import {
  getTheme,
  IconButton,
  Panel,
  PanelType,
  Stack,
  StackItem,
  Text,
} from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import HeaderLink from "./components/HeaderLink";
import { productNameStyle, smallHeaderStyle } from "./styles";
import { UserHeaderControl } from "components/auth/login";

import { URLS, EXPLORER_ENABLED } from "utils/constants";

export const HeaderOverflow: React.FC = () => {
  const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] = useBoolean(false);

  return (
    <Stack
      className={smallHeaderStyle}
      horizontal
      tokens={headerTokens}
      horizontalAlign="space-between"
      verticalAlign="center"
    >
      <Stack horizontal>
        <HeaderLink to="/">
          <Text block variant="medium" className={productNameStyle}>
            Planetary Computer Pro
          </Text>
        </HeaderLink>
      </Stack>
      <StackItem>
        <Stack horizontal verticalAlign="center" tokens={rightSectionTokens}>
          <UserHeaderControl compact />
          <IconButton
            ariaLabel="Navigation overflow menu"
            iconProps={overflowIconProps}
            onClick={openPanel}
          />
        </Stack>
        <Panel
          isLightDismiss
          isOpen={isOpen}
          onDismiss={dismissPanel}
          type={PanelType.custom}
          customWidth="200px"
        >
          <Stack tokens={panelLinkTokens} verticalAlign="start">
            <HeaderLink
              align="start"
              isNav
              to={`${URLS.collections}`}
              color={theme.semanticColors.bodyText}
            >
              Collections
            </HeaderLink>
          </Stack>
          <HeaderLink
            align="start"
            isNav
            to={`${URLS.settings}`}
            color={theme.semanticColors.bodyText}
          >
            Settings
          </HeaderLink>
          {EXPLORER_ENABLED && (
            <HeaderLink
              align="start"
              isNav
              to={`${URLS.explorer}`}
              color={theme.semanticColors.bodyText}
            >
              Explorer
            </HeaderLink>
          )}
          <HeaderLink
            align="start"
            isNav
            to={`${URLS.docs}`}
            target="_blank"
            color={theme.semanticColors.bodyText}
          >
            Documentation
          </HeaderLink>
        </Panel>
      </StackItem>
    </Stack>
  );
};

const theme = getTheme();

const overflowIconProps = {
  iconName: "GlobalNavButton",
  styles: {
    root: {
      fontSize: 20,
      height: 20,
      lineHeight: 20,
      color: theme.palette.white,
    },
  },
};
const panelLinkTokens = { childrenGap: 15 };
const headerTokens = { childrenGap: "10px 21px" };
const rightSectionTokens = { childrenGap: 8 };
